import React, { useState } from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';
import '../css/CollapsibleSectionStyling.css';

const CollapsibleSection = ({
                                title,
                                icon: IconComponent,
                                iconColor = "default-icon-color",
                                badge,
                                children,
                                defaultExpanded = false,
                                headerClassName = "",
                                contentClassName = ""
                            }) => {
    const [isExpanded, setIsExpanded] = useState(defaultExpanded);

    const toggleExpanded = () => {
        setIsExpanded(prev => !prev);
    };

    return (
        <div className={`collapsible-section ${isExpanded ? 'expanded' : ''}`}>
            <button
                onClick={toggleExpanded}
                className={`collapsible-header ${headerClassName} ${isExpanded ? 'expanded' : ''}`}
            >
                <div className="collapsible-header-content">
                    {IconComponent && (
                        <IconComponent size={28} className={`icon-component ${iconColor}`} />
                    )}
                    <h3 className="collapsible-title">{title}</h3>
                    {badge && (
                        <span className="collapsible-badge">
                            {badge}
                        </span>
                    )}
                </div>
                <div className="collapsible-chevron">
                    {isExpanded ? <ChevronDown size={20} /> : <ChevronRight size={20} />}
                </div>
            </button>

            {isExpanded && (
                <div className={`collapsible-content ${contentClassName} ${isExpanded ? 'expanded' : ''}`}>
                    {children}
                </div>
            )}
        </div>
    );
};

export default CollapsibleSection;
